import { observer } from "mobx-react-lite";
import { RootStoreContext } from "../../app/stores/rootStore";
import Tree from "rc-tree";
import React, { useContext, useState } from "react";
// reactstrap components
import { IRepositoryUser } from "../../app/models/repositoryUser";

import "../../assets/scss/rc-tree/rc-tree.scss";
import TreeElement from "../common/TreeElement";
import TreeRepositoryIcon from "../common/TreeRepositoryIcon";
import TreeDocElement from "../common/TreeDocElement";

const STYLE = `
.rc-tree-child-tree {
  display: block;
}
.node-motion {
  transition: all .3s;
  overflow-y: hidden;
}
`;

interface IParams {
  tree: IRepositoryUser[];
}

const getAllNodes = (nodes: IRepositoryUser[]) => {
  let tempExpanded = nodes
    .filter((x) => x.children.length > 0)
    .map((n) => n.key);
  nodes.forEach((n) => {
    if (n.children.length !== 0) tempExpanded.push(...getAllNodes(n.children));
  });
  return tempExpanded;
};

const RepositoryTree: React.FC<IParams> = ({ tree }) => {
  const rootStore = useContext(RootStoreContext);
  const [expanded, setExpanded] = useState<string[]>(getAllNodes(tree));
  const { currentRepositoryTree } = rootStore.presentationStore;
  const { currentTenant } = rootStore.tenantStore;

  const handleExpand = (key: string) => {
    let copy = [...expanded];
    if (copy.includes(key)) copy = copy.filter((x) => x !== key);
    else copy.push(key);
    setExpanded(copy);
  };

  const formatNodes = (tree: IRepositoryUser[]) => {
    let retArray: any[] = [];

    tree.forEach((node) => {
      let childrenNodes = formatNodes(node.children);
      retArray.push({
        key: node.key,
        title: (
          <TreeDocElement
          titleNode={node.name}
            PresentationId={node.presentationId}
            link={
              node &&
              currentTenant &&
              node.presentationId > 0 &&
              node.hasContent
                ? `${currentTenant?.path}/repositoryBrowse/${node.presentationId}`
                : ""
            }
          />
        ),
        children: childrenNodes,
        icon: (
          <TreeRepositoryIcon
            nodeId={node.key}
            hasDocument={node.hasContent}
            presentationId={node.presentationId}
            expandedNode={expanded}
          />
        ),
      });
    });

    return retArray;
  };

  return (
    <>
      <div className="draggable-demo odgTree">
        <style dangerouslySetInnerHTML={{ __html: STYLE }} />
        {currentRepositoryTree && currentRepositoryTree.tree.length > 0 && (
          <Tree
            defaultExpandAll={true}
            treeData={formatNodes(tree)}
            onExpand={(selectedKeys, e) => {
              handleExpand(e.node.key.toString());
            }}
            showLine={true}
          />
        )}
      </div>
    </>
  );
};

export default observer(RepositoryTree);
